<template>
  <div id="scriptdetail">
    <el-row type="flex" justify="center">
      <el-col :xs="20" :sm="20" :md="18" :lg="14" :xl="12" v-loading="loading">
        <section class="hero is-info">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">
                <a
                  :href="js.downloadUrl"
                  target="_blank"
                  class="has-text-white"
                  >{{ js.scriptName }}</a
                >
              </h1>
              <h3 class="subtitle" style="margin-top:0.5em;font-size:1.2em">
                {{ js.description }}
              </h3>
            </div>
          </div>
        </section>
        <tags :js="js" style="margin-top:1em"></tags>
        <scriptinteractions
          :js="js"
          style="margin-top:1em"
        ></scriptinteractions>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import utils from "../utils";
import axios from "axios";
import tags from "./scripttags";
import scriptinteractions from "./scriptinteractions";
export default {
  name: "ScriptDetail",
  components: {
    tags,
    scriptinteractions,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      utils,
      js: {},
    };
  },
  async mounted() {
    this.loading = true;
    let data = await axios.get(utils.api.queryScriptByID(this.id));
    this.js = data.data.data;
    this.loading = false;
  },

  methods: {},

  computed: {},
};
</script>

<style lang="css"></style>
